// extracted by mini-css-extract-plugin
module.exports = {"footer":"PoFooter_footer__1icEn","approve":"PoFooter_approve__GfoHO","approve-ltr":"PoFooter_approve-ltr__1tAsC"};